import PayslipDisclaimer from "../../../../components/company/pay-slip/earnings/pay-slip-disclaimer";

const PayslipDisclaimerPage = () => {
    return <PayslipDisclaimer />
}

export default PayslipDisclaimerPage;